<template>
    <div class="template-wrapper">
		<h2 class="page-title">{{ $t("bookingRecord") }}</h2>
		<el-divider></el-divider>
		<template v-if="exportcsv === '1'">
            <el-button @click="exporttocsv($t('bookingRecord'))">{{ $t("exportBookingRecords") }}</el-button>
            <!--<div class="right-sidebar">
                <el-button @click="exporttocsv($t('bookingRecord'))">{{ $t("exportBookingRecords") }}</el-button>
            </div>-->
        </template>
       
    <template v-if="booking_read === '1'">
      <br />
      <br />
      <el-form ref="storeform" :model="storeform">
        <el-form-item :label="$t('selectStore')">
          <template>
            <div class="" style="display: flex">
              <el-select v-model="storeform.storeid" placeholder="" @change="changeStoreid">
                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                <el-option v-for="item in storelist" :label="item.storeid+' ('+item.name+')'" :value="item.storeid"></el-option>
              </el-select>
            </div>
          </template>
        </el-form-item>
      </el-form>
    </template>

    <template v-if="booking_read === '1'">
      <el-table
        :data="
          tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        "
        stripe
        @sort-change="sortChange"
        style="width: 100%">
        <el-table-column prop="addtime" :label="$t('time')" sortable="custom">
          <template slot-scope="scope">
            <div>{{ scope.row.addtime | formatDate }} </div>
          </template>
        </el-table-column>
        <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="whatsapp" :label="$t('phoneNumber')" sortable="custom">
        </el-table-column>
        <el-table-column prop="nickname" :label="$t('nickname')" sortable="custom">
        </el-table-column>
        <el-table-column prop="name" :label="$t('bookingname')" sortable="custom">
        </el-table-column>
        <el-table-column prop="service" :label="$t('bookingservice')" sortable="custom">
        </el-table-column>
        <el-table-column prop="bookingdate" :label="$t('bookingdate')" sortable="custom">
        </el-table-column>
        <el-table-column prop="bookingtime" :label="$t('bookingtime')" sortable="custom">
        </el-table-column>
      </el-table>
      <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t("total") }} {{tableData.length}} {{ $t("items") }}</span>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev,pager,next"
          :total="tableData.length"
        ></el-pagination>
      </div>
    </template>
    <template v-if="booking_read === '0'">
          <span>{{ $t("NoPermissions") }}</span>
      </template>



    </div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import {tongyong, getStore, getMetaTemplate, getBookingRecord, exportBookingRecord, addMetaTemplate, imageUpload,checkServiceEnable} from '@/api'
export default {
  data() {
    return {
      booking_read: '0',
        booking_edit: '0',
        exportcsv: '0',
        qyid: '',
        storeid: '',
      show:false,
      currentPage: 1, // 当前页码
      pageSize: 15, // 每页显示的行数
      dialogVisible: false,
      dialogEditFormVisible: false,
      tableData: [
      
      ],
      form: {
        qyid: "",
        storeid: "",
        template_name: "",
        text1: "",
        text2: "",
        isCatalog: 0,
        image: "",
        action: ""
      },
      editform: {
        id: "",
        qyid: "",
        storeid: "",
        template_name: "",
        text1: "",
        text2: "",
        isCatalog: 0,
        image: "",
        action: ""
      },
      huodonglist:[],
      storelist: [],
      storeform: {
				storeid: ''
			},

    };
  },
  filters: {
    formatDate: function (time) {
            time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
            let date = new Date(time)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      } 
    },
  created() {
	  var user = JSON.parse(window.localStorage.getItem("userinfo"));
	  //console.log(user)
	  //this.qyid = user.id
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
    this.qyid = auser.qyid
    this.storeid = auser.storeid
    if(auser.storeid) {
        this.storeform.storeid = auser.storeid
    }
    this.booking_read = auser.booking_read
    this.exportcsv = auser.exportcsv
    this.checkBookingServiceEnable();
    this.getlist(auser.storeid);
    //this.gethuodonglist()
    this.getstorelist();
  },

  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogEditFormVisible = false;
    },

    getlist(storeid) {
		this.show=true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
        qyid: this.qyid,
        storeid: storeid,
        record_page: this.currentPage,
        record_limit: 15,
    };
        getBookingRecord(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
		this.show=false
      });




    },
    checkBookingServiceEnable() {
      let fdata = {
					qyid: this.qyid,
          storeid: this.storeid,
          action: 'checkservice'
				};
				getStore(fdata).then((res) => {
					if (res.code == 1) {
                        console.log("checkBookingServiceEnable");
						console.log(res);
						//this.storelist = res.data
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
    },
    getstorelist() {
				console.log('go taocan');
				var user = JSON.parse(window.localStorage.getItem('userinfo'))

				let fdata = {
					qyid: this.qyid,
                    storeid: this.storeid
				};
				getStore(fdata).then((res) => {
					if (res.code == 1) {
						console.log(res);
						this.storelist = res.data
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			},
			changeStoreid() {
				console.log('storeid:' + this.storeform.storeid)
				this.getlist(this.storeform.storeid)
			},
            exporttocsv(name) {
        let fdata = {
            //qyid: user.id,
            qyid: this.qyid,
            storeid: this.storeform.storeid,
        };
        exportBookingRecord(fdata).then(res => {
            if (res.code == 1) {
                //this.tableData = res.data
                //this.totalRecord = res.total;
                this.tableDataExcel = res.dataExcel
                var csvContent= [
                    Object.keys(this.tableDataExcel[0]).join(","),
                        ...this.tableDataExcel.map(item => Object.values(item).join(","))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");
                var link = document.createElement('a');
                // "\ufeff"是为了解决CSV中文乱码问题
                var blob = new Blob(["\ufeff" +csvContent],{type: 'text/csv;charset=utf-8;'});
                var url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', name + '.csv');
                link.click();
                document.body.removeChild(link);
                    } else {
                        //console.log('eeeeeeeeeeeeeeeeeeeeee')
                        this.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                })

		},
    sure() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)
    
	  if(!this.form.template_name) {
	  		    this.$message.error("請輸入範本名稱");
	  		   return
	  }
      
      //this.form.qyid= user.id
      this.form.qyid= this.qyid
      this.form.action= "add"
	  
      
      addMetaTemplate(this.form).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogVisible = false;
          this.getlist(this.storeform.storeid);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    edit() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)
    
	  if(!this.editform.template_name) {
	  		    this.$message.error(this.$t("pleaseEnterTemplateName"));
	  		   return
	  }
      
      //this.editform.qyid= user.id
      this.editform.qyid= this.qyid
      this.editform.action= "edit"
	  
      
      addMetaTemplate(this.editform).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogEditFormVisible = false;
          this.getlist(this.storeform.storeid);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    edititem(data) {
				this.editform = data
				this.dialogEditFormVisible = true
        console.log("data")
        console.log(data)
		},
    delitem(id) {
      this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

					console.log('del..');
          var user = JSON.parse(window.localStorage.getItem("userinfo"));
					let deletedata = {
						action: 'delete',
						id: id,
                        //qyid: user.id
                        qyid: this.qyid
					}
					addMetaTemplate(deletedata).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.dialogEditFormVisible = false;
              this.getlist(this.storeform.storeid);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
				}).catch(_ => {



				})


			},
      sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop,order));
    },
    compare (propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    }
  },
  



};
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}
.pendingList-wrapper {
}
.pagination {
width: 100%;
margin: 30px auto;
}
::v-deep .el-select {
width: 100%;
}
.right-sidebar {
  float: right;
}
</style>